module.exports = __webpack_public_path__ + "img/bell_2.f3bff63a.jpg";